import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-pap-header',
  templateUrl: 'pap-header.component.html',
  styleUrls: ['./pap-header.component.less', '../../shared/common.less'],
})

export class PapHeaderComponent implements OnInit {
  @Input() step: number = 1;
  ngOnInit(): void {
  }
}
